var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvice = function SvgAdvice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 49"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14642E",
    d: "M34.04 14.065a14.51 14.51 0 0 0-10.308-4.217h-.12c-7.969.035-14.388 6.54-14.354 14.509a14.4 14.4 0 0 0 4.079 9.982c1.773 1.858 2.96 4.199 3.356 6.729a2.696 2.696 0 0 0 2.702 2.323h8.691a2.78 2.78 0 0 0 2.702-2.323 12.4 12.4 0 0 1 3.373-6.781 14.42 14.42 0 0 0 4.045-9.603v-.413a14.28 14.28 0 0 0-4.165-10.206M18.563 45.283H28.94c1.032 0 1.858.826 1.858 1.858A1.85 1.85 0 0 1 28.941 49H18.563a1.85 1.85 0 0 1-1.859-1.859c0-1.032.843-1.858 1.859-1.858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3DC869",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8,
    d: "M12.492 23.563c.035-1.101.603-4.25 2.324-6.247M6 9.156l3.735 3.735M41.508 9.036l-3.735 3.735M23.383 1v5.266"
  })));
};
export default SvgAdvice;